import React, {useRef} from "react";

import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

const EventThemesBase = ({ themesData }) => {

    if (!themesData) return null;

    const { theme_title, theme_subtitle, theme_list } = themesData;

    const beforeListCreative = "absolute top-0 left-0 w-[40px] h-[40px] bg-[#ffe94d] z-10 rounded-full z-10";

    return (
        <div className="flex justify-center lg:justify-end" id="themeslist">
            <div className="relative">

                    <h2 className="text-4xl uppercase mb-6">{theme_title}</h2>

                {theme_list.map((theme, index) => (
                    <div className="flex flex-wrap mb-6 relative theme-item">
                        <div
                            className="w-[40px] h-[40px] mr-[15px] z-20 flex justify-center items-center text-4xl">
                            <span>{index + 1}</span>
                        </div>
                        <div className="w-[calc(100%-55px)]">
                            <h3 className="uppercase mb-1 text-xl">{theme.title}</h3>
                            <p>{theme.desc}</p>
                        </div>
                        {/*<div className={beforeListCreative}></div>*/}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default EventThemesBase;